// @flow
import type {Node} from 'react';

import {BreakpointProvider, ConfigurationProvider} from '@travel-frontend/core';
import {Provider} from 'react-redux';
import {BrowserRouter as ReactRouter} from 'react-router-dom';

import {ErrorBoundary} from 'components/ErrorBoundary';
import {BreakpointSetter} from 'components/Layout/components/Breakpoint';
import {ThemeWrapper} from 'components/ThemeWrapper';
import {config} from 'config';
import {configureStore} from 'redux/config';
import {Routes} from 'routes';

export const AppContainer = (): Node => {
  return (
    <ConfigurationProvider
      value={{
        portal: config.agent,
        authUrl: config.authUrl,
        domain: config.portalDomain,
        brandName: config.brandName,
        linkMaskingKey: config.portalShort,
        newsletterApiKey: '',
        newsletterSubscribeUrl: '',
        origin: config.portalOrigin,
        loginUrl: config.loginUrl,
        useNextImage: false,
        directusImageUrl: config.directusImageUrl,
      }}
    >
      <Provider store={configureStore()}>
        <ThemeWrapper portalShort={config.portalShort}>
          <BreakpointProvider>
            <ErrorBoundary>
              <BreakpointSetter>
                <ReactRouter basename={process.env.PUBLIC_PATH}>
                  <Routes />
                </ReactRouter>
              </BreakpointSetter>
            </ErrorBoundary>
          </BreakpointProvider>
        </ThemeWrapper>
      </Provider>
    </ConfigurationProvider>
  );
};
